import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent implements OnInit, OnChanges {
  @Input() imageUrl: string | null = null;
  @Input() alt: string = 'Avatar';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() placeholderText: string = '?';
  @Input() showBorder: boolean = false;
  @Input() borderColor: string = '#e0e0e0';

  public hasImage: boolean = false;
  public displayText: string = '';

  ngOnInit(): void {
    this.updateDisplayState();
  }

  ngOnChanges(): void {
    this.updateDisplayState();
  }

  private updateDisplayState(): void {
    this.hasImage = !!(this.imageUrl && this.imageUrl.trim() !== '');

    if (!this.hasImage) {
      // Extract initials from alt text or use placeholder text
      this.displayText = this.extractInitials(this.alt) || this.placeholderText;
    }
  }

  private extractInitials(text: string): string {
    if (!text || text.trim() === '') return '';

    const words = text.trim().split(/\s+/);
    if (words.length === 1) {
      return words[0].charAt(0).toUpperCase();
    }

    return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
  }

  onImageError(): void {
    this.hasImage = false;
    this.displayText = this.extractInitials(this.alt) || this.placeholderText;
  }
}
